 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import TEXTHALFTITLE from '@/components/Text/HalfTitle'
 import TEXTTITLEPAGE from '@/components/Text/TitlePage'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTFRONTOTHER01 from '@/components/Text/FrontOther01'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTGLOSSARYANDABBREVIATIONS from '@/components/Text/GlossaryandAbbreviations'
 import TEXTILLUSTRATIONSANDTABLES from '@/components/Text/IllustrationsandTables'
 import TEXTCHRONOLOGY from '@/components/Text/Chronology'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTCHAPTER01 from '@/components/Text/Chapter01'
 import TEXTCHAPTER02 from '@/components/Text/Chapter02'
 import TEXTCHAPTER03 from '@/components/Text/Chapter03'
 import TEXTCHAPTER04 from '@/components/Text/Chapter04'
 import TEXTCHAPTER05 from '@/components/Text/Chapter05'
 import TEXTCHAPTER06 from '@/components/Text/Chapter06'
 import TEXTCHAPTER07 from '@/components/Text/Chapter07'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import TEXTABBREVIATIONSUSEDINNOTES from '@/components/Text/AbbreviationsUsedinNotes'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTBIBLIOGRAPHY from '@/components/Text/Bibliography'
 import TEXTABOUTAUTHOR from '@/components/Text/AboutAuthor'
 import TEXTBACKOTHER01 from '@/components/Text/BackOther01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Cover",
 			"name" : "Text/Cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/HalfTitle",
 			"name" : "Text/HalfTitle",
 			"component" : TEXTHALFTITLE
 		},
 		{
 			"path" : "/Text/TitlePage",
 			"name" : "Text/TitlePage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/FrontOther01",
 			"name" : "Text/FrontOther01",
 			"component" : TEXTFRONTOTHER01
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/GlossaryandAbbreviations",
 			"name" : "Text/GlossaryandAbbreviations",
 			"component" : TEXTGLOSSARYANDABBREVIATIONS
 		},
 		{
 			"path" : "/Text/IllustrationsandTables",
 			"name" : "Text/IllustrationsandTables",
 			"component" : TEXTILLUSTRATIONSANDTABLES
 		},
 		{
 			"path" : "/Text/Chronology",
 			"name" : "Text/Chronology",
 			"component" : TEXTCHRONOLOGY
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/Chapter01",
 			"name" : "Text/Chapter01",
 			"component" : TEXTCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js